import { Card, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Question from "./Question";

export default function QuizItem({ item }) {
  console.log(item);
  return (
    <Card sx={{
      p: 3,
    }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>{item.title}</Typography>
      <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
        {item.description || "Dieses Quiz hat keine Beschreibung."}
      </Typography>
      <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {item.questions && item.questions.map((question, index) => (
          <Question key={index} question={question} />
        ))}
      </Box>
    </Card>
  );
}